"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Combobox_1 = require("../../Combobox");
var helpers_1 = require("../../../helpers");
var StyledCombobox = styled_components_1.default(Combobox_1.Combobox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &:nth-child(n + 2) {\n        margin-left: ", ";\n    }\n"], ["\n    &:nth-child(n + 2) {\n        margin-left: ", ";\n    }\n"])), helpers_1.SPACING_XS);
function createValueComboboxLinkControl(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.textGetter, textGetter = _c === void 0 ? function (value) { return "" + value; } : _c, customOptions = _b.options;
    return function valueComboboxLinkControlRenderer(_a) {
        var disabled = _a.disabled, options = _a.options, value = _a.value, onValueChange = _a.onValueChange;
        return (react_1.default.createElement(StyledCombobox, { value: value, data: customOptions || options, disabled: disabled, valueGetter: function (_a) {
                var value = _a.value;
                return value;
            }, textGetter: function (_a) {
                var value = _a.value, title = _a.title;
                return title || textGetter(value);
            }, controlRenderer: Combobox_1.createLinkControl(), onChange: onValueChange, placeholder: "" + value }));
    };
}
exports.createValueComboboxLinkControl = createValueComboboxLinkControl;
var templateObject_1;
//# sourceMappingURL=valueComboboxLinkControlRenderer.js.map